<template>
  <div>
    <CRow>
      <CCol md="12">
        <div
          style="
            height: 700px;
            width: 740x;
            padding: 10px;
            border: 1px solid gray;
            position: relative;
          "
        >
          <CRow alignHorizontal="end" class="action">
            <b-button
              variant="primary"
              class="btn-addbox"
              @click.prevent="addElement"
            >
              {{ $t("seat_employee.button.add_seat_employee") }}
              <!-- <CIcon name="cil-account-logout" /> -->
            </b-button>
            <b-button variant="danger" v-on:click="showModalDelete">
              {{ $t("seat_employee.button.remove_seat_employee") }}
              <!-- <CIcon name="cil-account-logout" /> -->
            </b-button>
            <template>
              <b-modal ref="my-modal-delete" hide-footer hide-header>
                <p class="info" style="font-size: 15px">
                  {{ $t("commons.label_delete") }}?
                </p>
                <div class="btn-submit">
                  <b-button
                    class="btn-save"
                    variant="danger"
                    @click="deleteTable"
                    >{{ $t("button.label_action_delete") }}</b-button
                  >
                  <b-button class="btn-save" @click="hideModalDelete">{{
                    $t("seat_employee.button.cancel_seat_employee")
                  }}</b-button>
                </div>
              </b-modal>
            </template>
          </CRow>
          <vue-draggable-resizable
            v-for="(element, index) in listSeatEmployee"
            :key="index"
            :parent="true"
            :resizable="true"
            :hidden="false"
            :x="element.x"
            :y="element.y"
            class="dnd-table"
            :w="element.width"
            :h="element.height"
            @dragstop="onDrag"
            @resizestop="onResize"
            @activated="onActivated(element, index)"
            :style="{ background: element.color }"
          >
            <div class="name-table" v-on:dblclick="showModal">
              {{ element.name }}
            </div>
          </vue-draggable-resizable>
        </div>
      </CCol>
      <template>
        <b-modal ref="my-modal" hide-footer hide-header>
          <h5 class="info">
            {{ $t("seat_employee.label_info_employee") }}
          </h5>
          <CRow>
            <CCol md="12" class="form-field">
              <label>{{ $t("seat_employee.label_name") }}</label>
              <input v-model="item.name" class="form-control" />
            </CCol>
          </CRow>
          <CRow class="info-value">
            <CCol ms="12" class="form-field">
              <label>{{ $t("seat_employee.label_employee_id") }}</label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('project.employee')"
              >
                <multiselect
                  v-model="myValue"
                  :options="getAllEmployee.employees"
                  placeholder="Search nhân viên"
                  :custom-label="nameWithLang"
                  label="name"
                  track-by="name"
                ></multiselect>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow class="info-value">
            <CCol md="12" class="form-field">
              <label>{{ $t("seat_employee.label_employee_note") }}</label>
              <input v-model="item.note" class="form-control" />
            </CCol>
          </CRow>
          <div class="btn-submit">
            <b-button
              class="btn-save"
              variant="primary"
              @click.prevent="onSubmit"
              >{{ $t("seat_employee.button.save_seat_employee") }}</b-button
            >
            <b-button class="btn-save" @click="hideModal">{{
              $t("seat_employee.button.cancel_seat_employee")
            }}</b-button>
          </div>
        </b-modal>
      </template>
    </CRow>
  </div>
</template>

<script>
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import { ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "LayoutSeat",
  components: {
    VueDraggableResizable,
    ValidationProvider,
    Multiselect,
  },
  props: {
    listSeatEmployee: {
      type: Array,
      default: () => [],
    },
    getAllEmployee: {
      type: Object,
      default: () => {},
    },
    floors: {
      type: Number,
      default: null,
    },
  },
  data: function () {
    return {
      index: null,
      width: 0,
      height: 0,
      item: {},
      select: "",
      idTable: "",
      myValue: "",
      selected: [],
    };
  },
  // computed: {
  //   filterListSeat: function() {
  //     const listSeat = this.getAllEmployee.employees.map(e => ({id: e.id, text: e.text + ' ' + e.department_code}))
  //     return listSeat;
  //   }
  // },
  methods: {
    ...mapActions("layout", ["setLoading"]),

    nameWithLang({ name, department_code }) {
      return `${name} — ${department_code}`;
    },

    async addElement() {
      this.active = false;
      this.listSeatEmployee.push({
        name: "Table",
        floor: this.floors,
        x: 50,
        y: 100,
        width: 90,
        height: 50,
        hidden: false,
        pinned: false,
      });
      this.setLoading(true);
      await this.$store
        .dispatch("seat-employee/createSeatEmployee", {
          name: "Table",
          floor: this.floors,
          x: 50,
          y: 100,
          hidden: false,
          pinned: false,
          width: 90,
          height: 50,
        })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_create_table"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
          this.$emit("handleFloor", this.floors);
          this.$emit("getEmployee");
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    showModalDelete() {
      this.$refs["my-modal-delete"].show();
    },
    hideModalDelete() {
      this.$refs["my-modal-delete"].hide();
    },

    onActivated: function (element, index) {
      element.active = false;
      this.index = index;
      this.item = element;
      this.idTable = element.id;
    },
    onResize: function (x, y, width, height) {
      this.listSeatEmployee[this.index]["x"] = x;
      this.listSeatEmployee[this.index]["y"] = y;
      this.width = width;
      this.height = height;
      this.listSeatEmployee[this.index]["width"] = this.width;
      this.listSeatEmployee[this.index]["height"] = this.height;
      this.$store.dispatch("seat-employee/updateSeatEmployee", {
        id: this.idTable,
        data: this.item,
      });
    },
    onDrag: function (x, y) {
      this.listSeatEmployee[this.index]["x"] = x;
      this.listSeatEmployee[this.index]["y"] = y;
      this.$store.dispatch("seat-employee/updateSeatEmployee", {
        id: this.idTable,
        data: this.item,
      });
    },
    async onSubmit() {
      if (this.myValue !== "") {
        this.listSeatEmployee[this.index]["name"] = this.myValue.name;
      }
      this.listSeatEmployee[this.index]["employee_id"] = this.myValue.id;
      this.setLoading(true);
      await this.$store
        .dispatch("seat-employee/updateSeatEmployee", {
          id: this.idTable,
          data: this.item,
        })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_update_table"),
            null,
            2000,
            "b-toaster-top-center",
            "info"
          );
          this.hideModal();
          this.$emit("handleFloor", this.floors);
          this.$emit("getEmployee");
          this.myValue = "";
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    async deleteTable() {
      this.setLoading(true);
      await this.$store
        .dispatch("seat-employee/deleteSeatEmployee", this.idTable)
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_delete_table"),
            null,
            2000,
            "b-toaster-top-center",
            "danger"
          );
          this.$emit("handleFloor", this.floors);
          this.$emit("getEmployee");
          this.hideModalDelete();
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
  },
};
</script>
<style lang="scss">
.seat {
  border: 1px solid gray;
  padding: 10px;
  margin-bottom: 30px;
  box-shadow: 0px 4px 8px 0;
}
.title {
  text-align: center;
  padding-bottom: 15px;
}
.dnd-table {
  border: 1px solid;
  text-align: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.btn-edit {
  margin: 15px 0 15px 90px;
}
.btn-submit {
  padding: 20px 0 10px 0;
  text-align: center;
}
.btn-save {
  margin-right: 15px;
}
.info {
  text-align: center;
}
.info-value {
  padding-top: 15px;
}
.action {
  padding: 0 15px 15px 0;
}
.btn-addbox {
  margin-right: 15px;
}
.list-employee {
  border: 1px solid gray;
  margin: 20px 0;
}
.label-list {
  padding: 10px 0 0 20px;
}
.check-box {
  display: flex;
  text-align: center;
  padding: 5px 5px 10px 3px;
}
.name-table {
  cursor: pointer;
}
.select2-custom .select2-selection {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  height: calc(1.5em + 0.75rem + 2px);
  display: block;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  color: #768192;
  background-color: #fff;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select2-custom .select2-selection:focus {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}
.select2-container {
  width: 100% !important;
}

.employee-table {
  margin: 15px 5px;
  .cl-pointer {
    cursor: pointer;
    .icon-sort {
      margin-left: 5px;
      .c-icon {
        width: 12px;
      }
      .sort-rotate {
        transform: rotate(180deg);
      }
    }
  }
}
th,
td {
  vertical-align: middle !important;
}
@media only screen and (max-device-width: 767px) {
  .employee-table {
    margin: 0 20px;
  }
  .table-mobile {
    width: 1500px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .employee-table {
    margin: 1rem;
  }
  .table-tablet {
    width: 1500px;
    overflow-x: scroll;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
